import React from 'react';
import * as Oidc from "redux-oidc";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import AuthService from '../../services/authService';
import authenticationManager from '../../utils/authenticationManager';
import Loader from '../../components/loader';


/**
 * @class Callback
 * @description Identity will redirect the successful login here.
 */
class Callback extends React.Component {

	/**
	 * @function constructor
	 * @param {*} props - Having properties passed by parent element
	 *  * used for state initialization
	 */
     constructor(props) {
          super(props);
          this.state = {}
     }

     inIframe = () => {
          try {
               console.log(window.self , window.top, window);
               return window.self !== window.top;
          } catch (e) {
               return false;
          }
     }
     /**
      * @function render
      * @description repaints the component on each change of state and props value
      */
     render() {

          return (
               <Oidc.CallbackComponent userManager={authenticationManager}
                    successCallback={
                         (success) => {
                              const url = localStorage.getItem("LoadedUrl");
                              if (url && url.indexOf("/login") === -1) {
                                window.location.href = url;
                              } else {
                                this.props.history.push("/home");
                              }
                         }
                    }
                    errorCallback={
                         (error) => {
                              this.props.history.push("/home")
                         }
                    }
               >
                    <Loader showBackdrop />
               </Oidc.CallbackComponent>
          );

     }
}


/**
 * For mapping necessary state variables to current component properties
 * @param {Object} state - Immutable State Object
 * @return properties needed from state 
 */
const mapStateToProps = (state) => {
     return {
          isAuthenticated: AuthService.isAuthenticated(state)
     }
};
function mapDispatchToProps(dispatch) {
     return {
          dispatch
     };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Callback));